/* eslint-disable import/no-unresolved */
/* eslint-disable no-unused-vars */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { Button, Image } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBars } from '@fortawesome/free-solid-svg-icons'
import { mobilePhone, wavenet_logo } from '../asset'
import CIIcon from './CIIcon'

function IntroWith320HStaticPreview({ srcs, resetKey, redirectUrl }) {
  const validImages = Array.isArray(srcs) ? srcs.filter((src) => src.file) : []
  const [showIntro, setShowIntro] = React.useState(true)
  const [showMain, setShowMain] = React.useState(false)

  const IntroVideo = srcs.find((s) => s.label === 'Intro video')
  const MainImg = srcs.find((s) => s.label === 'Main img')

  const getPreviewURL = (file) => {
    if (file instanceof File || file instanceof Blob) {
      return URL.createObjectURL(file)
    }
    if (typeof file === 'string') {
      return file
    }
    return ''
  }

  useEffect(() => {
    if (!showIntro) return undefined

    const timer = setTimeout(() => {
      setShowIntro(false)
      setShowMain(true)
    }, 3000)

    return () => clearTimeout(timer)
  }, [showIntro])

  React.useEffect(() => {
    setShowIntro(true)
    setShowMain(false)
  }, [resetKey])

  const isVideo = (entry) => {
    if (!entry) return false

    if (typeof entry.type === 'string') {
      return entry.type.startsWith('video')
    }

    if (typeof entry.file === 'string') {
      return entry.file.endsWith('.mp4') || entry.file.startsWith('blob:')
    }

    return false
  }

  return (
    <div
      className="scroller-hide"
      style={{ maxHeight: '57.5vh', overflow: 'auto' }}
    >
      <div className="w-100 pb-1">
        <Image
          className="position-absolute"
          src={mobilePhone}
          style={{ width: '19.5rem', right: '16%', top: '2%' }}
        />
        <div style={{ position: 'relative' }}>
          <div
            className="border-bottom mb-3 d-flex"
            style={{ width: '240px', height: '55px', zIndex: '0' }}
          >
            <div className="w-80 m-auto ms-auto">
              <Image src={wavenet_logo} className="w-75 ps-3" />
            </div>
            <div className="w-20 m-auto ms-auto d-flex">
              <FontAwesomeIcon icon={faBars} className="text-end" />
            </div>
          </div>
          <div className="text-title" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-ban1" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line2" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <br />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <br />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <br />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
        </div>
      </div>

      {showIntro && IntroVideo?.file && (
        <div
          className="position-absolute"
          style={{
            width: '240px',
            right: '19.1%',
            maxHeight: '470px',
            overflow: 'hidden',
            bottom: '11%',
            zIndex: 1000,
            display: 'flex',
            alignItems: 'flex-end',
          }}
        >
          {isVideo(IntroVideo) ? (
            <video
              src={getPreviewURL(IntroVideo.file)}
              autoPlay
              muted
              playsInline
              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
            />
          ) : (
            <img
              src={getPreviewURL(IntroVideo.file)}
              alt="Intro"
              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
            />
          )}
        </div>
      )}

      {showMain && MainImg?.file && (
        <div
          className="position-absolute"
          style={{
            width: '240px',
            right: '19.1%',
            maxHeight: '360px',
            overflow: 'hidden',
            bottom: '11%',
            zIndex: 1000,
            display: 'flex',
            alignItems: 'flex-end',
          }}
        >
          {MainImg.file.type?.startsWith('video') ? (
            <>
              <video
                src={getPreviewURL(MainImg.file)}
                autoPlay
                muted
                controls
                loop
                playsInline
                style={{ width: '100%', height: '100%', objectFit: 'contain' }}
              />
              <CIIcon />
            </>
          ) : (
            <div
              role="presentation"
              onClick={() => {
                if (redirectUrl) window.open(redirectUrl, '_blank')
              }}
              style={{ width: '100%', height: '100%', cursor: 'pointer' }}
            >
              <img
                src={getPreviewURL(MainImg.file)}
                alt="Main"
                style={{ width: '100%', height: '100%', objectFit: 'contain' }}
              />
              <CIIcon />
            </div>
          )}
          <Button
            onClick={() => setShowMain(false)}
            style={{
              position: 'absolute',
              top: '6px',
              left: '6px',
              border: 'none',
              borderRadius: '50%',
              background: 'rgba(0, 0, 0, 0.5)',
              zIndex: 1501,
              height: '23px',
              width: '23px',
              fontSize: '12px',
              padding: '2px',
            }}
          >
            ✕
          </Button>
        </div>
      )}
    </div>
  )
}

IntroWith320HStaticPreview.propTypes = {
  srcs: PropTypes.arrayOf(
    PropTypes.shape({
      file: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.instanceOf(File),
        PropTypes.instanceOf(Blob),
      ]),
      label: PropTypes.string,
    })
  ),
  resetKey: PropTypes.number,
  redirectUrl: PropTypes.string,
}

IntroWith320HStaticPreview.defaultProps = {
  srcs: [],
  resetKey: 0,
  redirectUrl: '',
}

export default IntroWith320HStaticPreview
